'use client'

import { v4 as uuid } from 'uuid'

import { navigateToPage } from '@marketplace-web/browser/browser-navigation-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { urlWithParams } from '@marketplace-web/browser/url-util'
import { clickEvent } from '@marketplace-web/bundles/items-bundle-data'
import { getHomepageSessionIdFromUrl } from '@marketplace-web/home/home-page-util'

type RenderProps = {
  onClick: () => void
}

type Props = {
  itemIds?: Array<number> | null
  url: string
  screen: string
  children: (props: RenderProps) => JSX.Element
}

const StartBundleButtonWrapper = ({ url, screen, children, itemIds = null }: Props) => {
  const { track } = useTracking()

  const handleBuyBundleClick = () => {
    const bundleTrackingId = uuid()

    track(
      clickEvent({
        screen,
        target: 'start_bundle',
        targetDetails: JSON.stringify({
          bundle_id: bundleTrackingId,
        }),
      }),
    )

    const bundlePageUrl = urlWithParams(url, {
      item_ids: itemIds,
      bundle_id: bundleTrackingId,
      homepage_session_id: getHomepageSessionIdFromUrl(),
    })

    navigateToPage(bundlePageUrl)
  }

  return children({ onClick: handleBuyBundleClick })
}

export default StartBundleButtonWrapper
